import { render, staticRenderFns } from "./InsLocation.vue?vue&type=template&id=b528dbaa&scoped=true&"
import script from "./InsLocation.vue?vue&type=script&lang=ts&"
export * from "./InsLocation.vue?vue&type=script&lang=ts&"
import style0 from "./InsLocation.vue?vue&type=style&index=0&id=b528dbaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b528dbaa",
  null
  
)

export default component.exports